export default "__VITE_ASSET__DPJ6tBAE__"